import { createFileRoute } from '@tanstack/react-router'
import { BoxIcon, LayoutGridIcon, TriangleIcon, DiamondIcon } from 'lucide-react'
import { TransitionTabsSurface } from './-components/shared/transition-tabs'

// The ITEM pager — the report-tabs shape, inside the pushed stack screen, inside the outer pager. One
// declaration: TransitionTabsSurface owns the group identity, the current-member derivation and the
// preview gating (see shared/transition-tabs.tsx). Alpha/Gamma/Delta each host a nested SUB pager of
// their own (two nested transition tabs); Board is the heavy pane.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item')({
  component: () => (
    <TransitionTabsSurface
      scope="/dev-resources/transitions/one/item"
      tabs={[
        { segment: 'alpha', label: 'Alpha', icon: BoxIcon },
        { segment: 'board', label: 'Board', icon: LayoutGridIcon },
        { segment: 'gamma', label: 'Gamma', icon: TriangleIcon },
        { segment: 'delta', label: 'Delta', icon: DiamondIcon },
      ]}
    />
  ),
})
